module.exports = "<div class=\"modal-header\">\n    <h2> Attivazione senza menu </h2>\n</div>\n<p> </p>\n<p>\n    Stai cercando di attivare un vas senza avere prima creato un menu!\n    Per favore, instanzia almeno un menu prima di proseguire all'attivazione del vas\n</p>\n<footer>\n    <button class=\"button\" ng-click=\"okFunc()\"> {{ \"services.activations.buttons.activate.modal.button\" | translate}} </button>\n</footer>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/services/SuggestToMakeMenuModal.html
 ** module id = 504
 ** module chunks = 0
 **/